import React from "react";

const IFrame = React.memo(({ iframeRef, onLoad }) => (
    <iframe
        title="Frame Wrapper"
        onLoad={onLoad}
        ref={iframeRef}
        style={{ width: "100%", height: "100%" }}
    />
));

export default IFrame;
